export default {
  header: 'תשלומים נוספים',
  addNewExpense: 'הוספת תשלום',
  sum: 'סכום',
  type: 'שם תשלום',
  date: 'תאריך',
  comments: 'הערות',
  isPaid: 'האם שולם',
  payDate: 'מתי שולם',
  sucess: 'התשלום נוסף בהצלחה',
  deletionReason: 'סיבת המחיקה',
  verifyDeletion: 'האם אתה בטוח שברצונך להעביר את התשלום לארכיון?',
  label: 'עריכת תשלום',
  delete: 'מחק תשלום',
};
